import { useI18n } from '../../i18n'
import styles from './YoutubeDataSaverToggle.module.css'

type Props = {
  enabled: boolean
  onChange: (enabled: boolean) => void
  /** Fuller copy for Local data; shorter beside the practice player. */
  variant?: 'panel' | 'inline'
  disabled?: boolean
  className?: string
}

export function YoutubeDataSaverToggle({
  enabled,
  onChange,
  variant = 'panel',
  disabled = false,
  className,
}: Props) {
  const { t } = useI18n()
  const headingId = 'youtube-data-saver-heading'
  const descId = 'youtube-data-saver-desc'

  return (
    <section
      className={`${styles.root} ${variant === 'inline' ? styles.inline : styles.panel} ${className ?? ''}`}
      aria-labelledby={headingId}
      aria-describedby={descId}
    >
      <div className={styles.header}>
        <h2 id={headingId} className={styles.title}>
          {t('youtube.dataSaver.title')}
        </h2>
        <label className={styles.switchLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            checked={enabled}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
            aria-describedby={descId}
          />
          <span className={styles.switchText}>
            {enabled ? t('youtube.dataSaver.on') : t('youtube.dataSaver.off')}
          </span>
        </label>
      </div>
      <p id={descId} className={styles.explanation}>
        {variant === 'inline'
          ? t('youtube.dataSaver.explanationShort')
          : t('youtube.dataSaver.explanation')}
      </p>
      {variant === 'panel' && (
        <p className={styles.note}>{t('youtube.dataSaver.note')}</p>
      )}
    </section>
  )
}
